import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';

function OpportunityLeadList(props) {
  const Config = {
    sale: {
      apiPath: '/opportunityOrder/pageList',
      enumMainKey: '',
      companyNameKey: 'customerInnerName',
      detailLink: '/mp/sale/opportunity-management/lead/detail',
      searchBarPlaceholder: '客户名称、商机名称、商机单号',
      tabs: ['全部', '完成询价', '未有价格'],
      countApi: '/opportunityOrder/count',
      arrEnumField: [
        {
          mainKey: 'B02_Opportunity_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Forecast_Cycle_Type',
          subKey: 'forecastCycleType',
          value: 'forecastCycleTypeName'
        },
        { mainKey: 'B_Inq_status', subKey: 'inqStatus', value: 'inqStatusName' }
      ],
      countTransform: (data, self) => {
        let { 1: a, 0: b } = data;
        setCount([undefined, a, b]);
      },
      tabConfig: [
        undefined, //全部
        1, // 完成询价
        0 // 未有价格
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  self.beforeSearch = async function () {
    self.searchQueries = {
      inqStatus: config.tabConfig[currentTab]
    };
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.oppXkNo}`}
                      key={item.id}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.oppInnerNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass('oppOrder', item.status)
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        {/* {self.isPurchase && (
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                        )} */}
                        {!self.isPurchase && (
                          <li>
                            <label>客户</label>
                            <div>
                              {item.customerInnerName}({item.customerInnerCode})
                            </div>
                          </li>
                        )}
                        <li>
                          <label>商机名称</label>
                          <div>{item.oppTitle}</div>
                        </li>
                        <li>
                          <label>发布时间</label>
                          <div>{formatDate(item.createTime, 'YYYY-MM-DD')}</div>
                        </li>
                        <li>
                          <label>发布人</label>
                          <div>{item.createName}</div>
                        </li>
                        <li>
                          <label>询价单状态</label>
                          <div>
                            <span
                              className={
                                'u-sign ' +
                                CommonFns.getStatusClass(
                                  'oppInq',
                                  item.inqStatus
                                )
                              }
                            >
                              {item.inqStatusName}
                            </span>
                          </div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

OpportunityLeadList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(OpportunityLeadList);
